module.exports = __webpack_public_path__ + "static/logo-158fb57c06f5c40f21e234ab6f4db7ce.png";